// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"yZ-z","subtitle":"zZ-z","wrapper":"AZ-z","leftArrow":"BZ-z","rightArrow":"CZ-z"};